import { useContext } from 'react'
import { toast } from 'react-toastify'

import { useRealtimeSubscription, useThunkDispatch } from '@domain-group/react-hooks'
import * as agencyActions from '@redux/modules/agency'

import RealtimeContext from '@contexts/realtimeContext'

import { AppDispatch } from '@redux/store'

import type { AgencyModel } from '@models/types'

type ProcessCopyAgencyDataParams = {
  agency: AgencyModel,
  success: boolean,
  dispatch: AppDispatch,
}

export const processCopyAgencyData = (params: ProcessCopyAgencyDataParams) => {
  const { agency, dispatch, success } = params

  if (success){
    toast('Agency Copied Successfully')
  } else {
    toast.warn('Copied with errors. See activity log')
  }

  const { hydrateAgency: updateFn } = agencyActions

  return dispatch(updateFn({ agency }))
}

const useCopyAgencyData = (agency: Partial<AgencyModel> = {}) => {
  const realtimeContext = useContext(RealtimeContext)
  // @ts-expect-error TS2339
  const { clientRef } = realtimeContext

  const dispatch = useThunkDispatch()

  // Realtime/Websocket Connection
  useRealtimeSubscription({
    apiKey: process.env.REACT_APP_ABLY_PUBLIC_KEY,
    callbacks: {
      success: (data: { payload: AgencyModel }) => processCopyAgencyData(
        // @ts-expect-error TS2339
        { agency: data.payload, dispatch, success: data.success },
      ),
    },
    channelName: 'agencies',
    clientRef,
    eventName: `agency.${agency.id}.copy_data_complete`,
  }, [agency.id])
}

export default useCopyAgencyData
